import { RewardProviderType } from '@kudos/http-client'
import { CelebrateSubTabs } from '@tenant/celebrate/useCelebrateSubTabs'
import { CelebrateTabs } from '@tenant/celebrate/useCelebrateTabs'
import { ResourceHubTabs } from '@tenant/resourceHub/useResourceHubTabs'
import { MySettingsTabs } from '@tenant/settings/useMySettingsTabs'
import AdminPaths from './admin'

type HomepageAnchors = 'forYou' | 'recognitions' | 'awards'

export default class TenantScopedPaths {
  public static me() {
    return '/profile/me'
  }
  public static home(anchor?: HomepageAnchors) {
    let homeUrl = '/home'
    if (!!anchor) {
      homeUrl = `${homeUrl}#${anchor}`
    }
    return homeUrl
  }
  public static viewDraftRecognition(id: string | ':id?') {
    return `/recognition/send/in-progress/${id}/edit`
  }
  public static viewDraftRecognitions() {
    return '/recognition/send/in-progress'
  }
  public static sendRecognition() {
    return '/recognition/send'
  }
  public static viewRecognition(id: string | ':id?') {
    return `/recognitions/${id}`
  }
  public static resourceHub(tab: ResourceHubTabs | ':tab?') {
    return `/resource-hub/${tab}`
  }
  public static viewResource(resourceId: string) {
    return `/resource-hub/resources/${resourceId}`
  }
  public static viewResourceComplete(resourceId: string) {
    return `/resource-hub/resources/${resourceId}/complete`
  }
  public static mySettings(tab: MySettingsTabs | ':tab?') {
    return `/settings/${tab}`
  }
  public static changePassword() {
    return '/settings/change-password'
  }
  public static nextCheckInQuestion(categoryId: string) {
    return `/check-ins/category/${categoryId}/question`
  }
  public static memberProfile(tenantMemberId: string) {
    return `/profile/${tenantMemberId}`
  }
  public static rewardsProviders() {
    return '/rewards/providers'
  }
  public static redemptionHistory() {
    return '/rewards/redemption-history'
  }
  public static reward(
    rewardProviderId: string,
    rewardId: string,
    rewardProviderType: RewardProviderType,
  ) {
    if (rewardProviderType === RewardProviderType.TANGO) {
      return `/rewards/providers/${rewardProviderId}/rewards/${rewardId}`
    }
    return `/rewards/${rewardProviderType}/${rewardProviderId}/rewards/${rewardId}`
  }
  public static rewardProvider(rewardProviderId: string) {
    return `/rewards/providers/${rewardProviderId}`
  }
  public static rewardStore(rewardProviderType: RewardProviderType, rewardProviderId: string) {
    if (rewardProviderType === RewardProviderType.TANGO) {
      return `/rewards/providers/${rewardProviderId}`
    }
    return `/rewards/${rewardProviderType}/${rewardProviderId}`
  }
  public static yourDirectReports() {
    return '/direct-reports'
  }
  public static celebrate(
    tab?: CelebrateTabs | ':tab?',
    subTab?: CelebrateSubTabs | ':subTab?',
    searchParams?: string,
  ) {
    let rootPath = `/celebrate/${tab ?? ''}`
    if (!!subTab) rootPath += `/${subTab}`
    if (!!searchParams) rootPath += `?${searchParams}`
    return rootPath
  }
  public static awards() {
    return '/awards'
  }
  public static viewAward(id: string | ':id?') {
    return `/award/${id}`
  }
  public static configureCard(cardId?: string | ':cardId?', searchParams?: string) {
    let baseUrl = '/celebrate/card'
    baseUrl = cardId ? `${baseUrl}/${cardId}` : baseUrl
    return searchParams ? `${baseUrl}?${searchParams}` : baseUrl
  }
  public static incentives() {
    return '/incentives'
  }
  public static culture() {
    return '/culture'
  }

  // hidden nav paths
  public static teamsLink() {
    return '/teams-link'
  }
  public static people() {
    return '/user-directory'
  }

  public static viewCard(cardId: string | ':cardId') {
    return `/card/${cardId}`
  }

  public static viewCardContributors(cardId: string | ':cardId') {
    return `/card/${cardId}/contributors`
  }

  public static spaces() {
    return '/spaces'
  }

  public static viewSpace(spaceId: string | ':spaceId') {
    return `/spaces/${spaceId}`
  }

  public static configureSpace(spaceId?: string | ':spaceId') {
    let baseUrl = '/spaces/configure'
    baseUrl = spaceId ? `${baseUrl}/${spaceId}` : baseUrl
    return baseUrl
  }

  // Mobile only paths
  public static notificationActivity() {
    return '/notification-activity'
  }

  public static menu() {
    return '/menu'
  }

  public static adminMenu() {
    return '/admin-menu'
  }

  public static admin = AdminPaths
}
